var _style, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _polygon, _g5, _polygon2, _g6, _path5, _path6, _path7, _path8, _path9, _path10, _polygon3, _path11, _path12, _path13, _path14, _g7, _g8, _path15, _polygon4, _polygon5, _polygon6, _polygon7, _path16, _path17, _path18, _polygon8, _path19, _g9, _polygon9, _polygon10, _path20, _path21, _g10, _polygon11, _polygon12, _g11, _g12, _g13, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _path22, _polygon21, _polygon22, _polygon23, _polygon24, _path23, _g14, _g15, _g16, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _polygon25, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _polygon26, _path54, _polygon27, _path55, _polygon28, _polygon29, _g17, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _path56, _g18, _path57, _polygon44, _polygon45, _g19, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _g20, _path74, _path75, _g21, _rect, _rect2, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _g22, _g23, _g24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartProject9420(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{opacity:0.1;}\r\n\t.st5{fill:#61607F;}\r\n\t.st6{fill:#FFAF6D;}\r\n\t.st7{fill:#FFC16B;}\r\n\t.st8{fill:#3D3E5D;}\r\n\t.st9{fill:#FB944B;}\r\n\t.st10{fill:#4F4E6E;}\r\n\t.st11{opacity:0.1;fill:#101416;}\r\n\t.st12{fill:#E9EDF6;}\r\n\t.st13{fill:#E57139;}\r\n\t.st14{fill:#BDC3E3;}\r\n\t.st15{fill:#E8EDF9;}\r\n\t.st16{fill:#D8DEF0;}\r\n\t.st17{fill:url(#SVGID_5_);}\r\n\t.st18{fill:url(#SVGID_6_);}\r\n\t.st19{fill:url(#SVGID_7_);}\r\n\t.st20{fill:url(#SVGID_8_);}\r\n\t.st21{fill:url(#SVGID_9_);}\r\n\t.st22{fill:url(#SVGID_10_);}\r\n\t.st23{fill:url(#SVGID_11_);}\r\n\t.st24{fill:#423EAF;}\r\n\t.st25{fill:url(#SVGID_12_);}\r\n\t.st26{fill:#FFFFFF;}\r\n\t.st27{fill:url(#SVGID_13_);}\r\n\t.st28{fill:#6D6C93;}\r\n\t.st29{fill:url(#SVGID_14_);}\r\n\t.st30{fill:url(#SVGID_15_);}\r\n\t.st31{fill:#282A46;}\r\n\t.st32{fill:#515696;}\r\n\t.st33{fill:#E1E5F1;}\r\n\t.st34{fill:url(#SVGID_16_);}\r\n\t.st35{fill:#D1D7F3;}\r\n\t.st36{fill:url(#SVGID_17_);}\r\n\t.st37{fill:url(#SVGID_18_);}\r\n\t.st38{fill:url(#SVGID_19_);}\r\n\t.st39{fill:url(#SVGID_20_);}\r\n\t.st40{fill:#FF826A;}\r\n\t.st41{fill:#F36B55;}\r\n\t.st42{fill:url(#SVGID_21_);}\r\n\t.st43{fill:url(#SVGID_22_);}\r\n\t.st44{fill:url(#SVGID_23_);}\r\n\t.st45{fill:url(#SVGID_24_);}\r\n\t.st46{fill:url(#SVGID_25_);}\r\n\t.st47{fill:url(#SVGID_26_);}\r\n\t.st48{fill:url(#SVGID_27_);}\r\n\t.st49{fill:url(#SVGID_28_);}\r\n\t.st50{opacity:0.33;fill:url(#SVGID_29_);}\r\n\t.st51{fill:url(#SVGID_30_);}\r\n\t.st52{fill:url(#SVGID_31_);}\r\n\t.st53{fill:url(#SVGID_32_);}\r\n\t.st54{fill:#A4ADD0;}\r\n\t.st55{fill:#BBC0E6;}\r\n\t.st56{fill:url(#SVGID_33_);}\r\n\t.st57{fill:url(#SVGID_34_);}\r\n\t.st58{fill:url(#SVGID_35_);}\r\n\t.st59{fill:#CED3F8;}\r\n\t.st60{fill:#F6F6FB;}\r\n\t.st61{fill:url(#SVGID_36_);}\r\n\t.st62{fill:url(#SVGID_37_);}\r\n\t.st63{fill:url(#SVGID_38_);}\r\n\t.st64{fill:#C85A2B;}\r\n\t.st65{fill:#FCD1A9;}\r\n\t.st66{fill:url(#SVGID_39_);}\r\n\t.st67{fill:url(#SVGID_40_);}\r\n\t.st68{fill:url(#SVGID_41_);}\r\n\t.st69{fill:url(#SVGID_42_);}\r\n\t.st70{fill:url(#SVGID_43_);}\r\n\t.st71{display:none;fill:#354575;}\r\n\t.st72{fill:#F2C39D;}\r\n\t.st73{fill:url(#SVGID_44_);}\r\n\t.st74{fill:url(#SVGID_45_);}\r\n\t.st75{fill:url(#SVGID_46_);}\r\n\t.st76{fill:url(#SVGID_47_);}\r\n\t.st77{fill:url(#SVGID_48_);}\r\n\t.st78{fill:url(#SVGID_49_);}\r\n\t.st79{fill:url(#SVGID_50_);}\r\n\t.st80{fill:url(#SVGID_51_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -120.4902,
    y1: -185.1878,
    x2: -26.042,
    y2: -185.1878,
    gradientTransform: "matrix(-0.6844 0.7291 -0.7291 -0.6844 -127.7251 -16.097)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7CB1F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#5569CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3A5D8B"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.62,92.12C6.9,74.03,5.97,43.74,23.54,24.47C41.11,5.2,70.53,4.24,89.25,22.33 c18.72,18.09,19.65,48.38,2.08,67.66C73.76,109.26,44.34,110.22,25.62,92.12z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -100.6532,
    y1: -511.8017,
    x2: -5.8826,
    y2: -511.8017,
    gradientTransform: "matrix(-0.5939 -0.8045 0.8045 -0.5939 445.0571 -281.4822)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82E9F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#5A9ACF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E828B"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.34,26.82C58,11.12,87.1,15.64,102.35,36.9c15.24,21.27,10.86,51.24-9.79,66.94 c-20.65,15.7-49.76,11.18-65.01-10.08C12.3,72.49,16.68,42.52,37.34,26.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -438.15,
    y1: -373.2213,
    x2: -345.1737,
    y2: -373.2213,
    gradientTransform: "matrix(0.9999 0.0124 -0.0124 0.9999 453.6766 434.5686)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7CB1F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#5569CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3A5D8B"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.17,57.12c-0.32,26.43-21.39,47.6-47.06,47.27c-25.67-0.33-46.22-22.02-45.9-48.46 C20.52,29.5,41.59,8.34,67.26,8.67C92.93,9,113.48,30.69,113.17,57.12z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -367.0614,
    y1: -517.4943,
    x2: -272.944,
    y2: -517.4943,
    gradientTransform: "matrix(0.7673 -0.6413 0.6413 0.7673 632.8808 254.6613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82E9F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#5A9ACF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E828B"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M91.14,32.11c16.46,20.28,13.84,50.47-5.86,67.42c-19.7,16.95-49.02,14.25-65.48-6.03 C3.34,73.22,5.96,43.03,25.66,26.08C45.36,9.13,74.68,11.83,91.14,32.11z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "20.82,45.29 16.17,45.29 23.13,49.31 23.13,49.31 11.18,56.2 15.84,56.2 27.78,49.31  "
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "11.18,53.52 4.22,49.5 16.17,42.6 23.13,46.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "20.19,44.93 21.29,45.56 9.35,52.46 8.25,51.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "15.21,51.19 14.11,51.82 7.15,47.8 8.25,47.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "11.18,56.2 23.13,49.31 23.13,46.62 11.18,53.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "14.11,51.82 15.21,51.19 15.21,53.88 14.11,54.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "11.18,56.2 4.22,52.18 4.22,49.5 11.18,53.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "9.35,52.46 8.25,51.82 8.25,54.51 9.35,55.14  "
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "43.13,47.05 27.04,47.05 36.62,52.58 27.04,58.11 43.13,58.11 52.72,52.58  "
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "27.04,44.79 16.94,38.96 27.04,33.13 37.13,38.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "31.33,35.61 32.84,36.48 22.74,42.31 21.23,41.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "32.84,41.44 31.33,42.31 21.23,36.48 22.74,35.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "27.04,58.11 36.62,52.58 36.62,42.11 27.04,47.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "31.07,45.31 32.58,44.44 32.58,54.91 31.07,55.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "36.62,42.84 27.04,48.38 27.04,47.94 36.62,42.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "27.04,47.94 37.13,42.11 37.13,38.96 27.04,44.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "31.33,42.31 32.84,41.44 32.84,44.59 31.33,45.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "27.04,58.11 17.45,52.58 17.45,42.11 27.04,47.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "23,45.31 21.49,44.44 21.49,54.91 23,55.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "17.45,42.84 27.04,48.38 27.04,47.94 17.45,42.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "27.04,47.94 16.94,42.11 16.94,38.96 27.04,44.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "22.74,42.31 21.23,41.44 21.23,44.59 22.74,45.46  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.0095,
    y1: 39.7524,
    x2: 33.2292,
    y2: 39.7524
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4C9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1909,
    style: {
      stopColor: "#D7DAED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4777,
    style: {
      stopColor: "#EDEFF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7524,
    style: {
      stopColor: "#FAFBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M32.88,38.74c-0.01-0.01-0.01-0.01-0.02-0.02l0,0l0,0c-0.21-0.26-0.46-0.42-0.65-0.42 c-1.34,0.02-2.28,0.06-2.48,0.06h0l-0.72,2.85h2.19c0,0,0,0,0,0L31.56,41l0.5-0.29l0,0l0.92-0.53l0,0 c0.14-0.08,0.24-0.25,0.24-0.55C33.23,39.36,33.1,39.02,32.88,38.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.0228,
    y1: 38.1721,
    x2: 29.6256,
    y2: 40.9482
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2981,
    style: {
      stopColor: "#EFF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8751,
    style: {
      stopColor: "#C7CCE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BDC3E3"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M30.97,38.67c-0.01-0.01-0.01-0.01-0.02-0.02l0,0l0,0c-0.21-0.26-0.46-0.42-0.65-0.42 c-1.34,0.02-2.28,0.06-2.48,0.06h0l-1.82,1.05c0.2-0.01,1.15-0.04,2.48-0.06c0.2,0,0.45,0.17,0.67,0.44 c0.22,0.28,0.35,0.62,0.35,0.89c0,0.28-0.09,0.44-0.22,0.53l1.79-1.03l0,0c0.14-0.08,0.24-0.25,0.24-0.55 C31.33,39.28,31.2,38.95,30.97,38.67z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M29.16,39.71c-0.22-0.28-0.47-0.45-0.67-0.44c-1.34,0.02-2.28,0.06-2.48,0.06c-0.2-0.24-1.15-1.37-2.48-2.93 c-0.2-0.23-0.45-0.35-0.67-0.33c-0.22,0.03-0.35,0.21-0.35,0.48c0,0.63,0.46,1.24,0.8,1.43l5.41,3.12c0.33,0.19,0.8,0.12,0.8-0.51 C29.51,40.33,29.38,40,29.16,39.71z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.087,
    y1: 36.1953,
    x2: 25.0065,
    y2: 39.52
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A5ABCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3932,
    style: {
      stopColor: "#AEB3D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4C9E4"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M23.3,37.79c-0.22-0.13-0.62-0.58-0.62-1.12c0-0.2,0.1-0.34,0.27-0.36c0.16-0.02,0.35,0.07,0.49,0.23 c1.01,1.19,1.8,2.12,2.21,2.61L23.3,37.79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.3199,
    y1: 38.9985,
    x2: 28.6168,
    y2: 41.2449
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A5ABCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5604,
    style: {
      stopColor: "#B5BADC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BBBFE2"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M28.71,40.91l-2.35-1.36c0.41-0.01,1.2-0.04,2.21-0.05c0.14,0,0.33,0.13,0.49,0.34 c0.17,0.22,0.27,0.47,0.27,0.67C29.34,41.05,28.93,41.04,28.71,40.91z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.1603,
    y1: 35.2886,
    x2: 26.3747,
    y2: 39.124
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3613,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5566,
    style: {
      stopColor: "#F9FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8179,
    style: {
      stopColor: "#E8ECF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8DEF0"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M22.86,36.08c0.21-0.03,0.47,0.1,0.67,0.33c1.34,1.56,2.28,2.69,2.48,2.93l1.63-0.94l0.19-0.11c0,0,0,0,0,0 c-0.2-0.24-1.15-1.37-2.48-2.93c-0.2-0.23-0.45-0.35-0.67-0.33c-0.07,0.01-0.13,0.04-0.18,0.07l0,0l-1.78,1.02 C22.75,36.1,22.8,36.08,22.86,36.08z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.4514,
    y1: 51.9101,
    x2: 19.7794,
    y2: 51.9101
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4C9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2101,
    style: {
      stopColor: "#D7DAED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    style: {
      stopColor: "#F4F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "17.45,49.89 19.78,53.93 17.45,52.58  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.793,
    y1: 61.2548,
    x2: 25.1029,
    y2: 61.2548
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4C9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4536,
    style: {
      stopColor: "#DCDFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M24.14,59.07L24.14,59.07L24.14,59.07c-1.75,0.28-3.7,0.03-5.08-0.77c-1.38-0.79-1.82-1.92-1.33-2.93 l-0.96-0.55L2.79,62.89l0.28,0.55c0,0,2.35-1.25,5.76,0.77c1.37,0.81,1.82,1.92,1.33,2.93l0.28,0.55h0.68l0,0l0,0h0l13.98-8.07 L24.14,59.07z"
  })), /*#__PURE__*/React.createElement("g", null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M17.05,55.37v-0.39c-0.16,0.33-0.22,0.67-0.18,1C16.9,55.77,16.96,55.57,17.05,55.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.0728,
    y1: 64.5366,
    x2: 9.6725,
    y2: 64.5366
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D3E5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F4E6E"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M8.15,63.82c-1.38-0.79-3.33-1.05-5.08-0.77l0,0v0.39c1.75-0.28,3.7-0.03,5.08,0.77 c0.93,0.54,1.43,1.23,1.51,1.93C9.76,65.3,9.25,64.45,8.15,63.82z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M18.38,57.91c-1.38-0.79-1.82-1.92-1.33-2.93l-0.96-0.55L2.11,62.49l0.96,0.55c1.75-0.28,3.7-0.03,5.08,0.77 c1.38,0.79,1.82,1.92,1.33,2.93l0.96,0.55l13.98-8.07l-0.96-0.55C21.71,58.96,19.76,58.7,18.38,57.91z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "13.02,56.84 13.28,56.7 12.72,56.37 12.46,56.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "13.99,57.4 14.25,57.26 13.69,56.93 13.43,57.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "14.96,57.96 15.22,57.82 14.66,57.49 14.4,57.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "15.93,58.53 16.19,58.38 15.63,58.05 15.37,58.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "16.91,59.09 17.16,58.94 16.6,58.61 16.34,58.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "17.88,59.65 18.13,59.5 17.57,59.18 17.32,59.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "18.85,60.21 19.1,60.06 18.54,59.74 18.29,59.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "19.82,60.77 20.07,60.62 19.51,60.3 19.26,60.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "20.79,61.33 21.04,61.18 20.48,60.86 20.23,61  "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "11.02,58.9 13.12,57.69 12.46,57.3 10.36,58.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "9.6,59.72 10.62,59.13 9.96,58.75 8.94,59.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "8.51,60.35 9.13,59.99 8.47,59.61 7.85,59.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "7.35,61.01 7.97,60.66 7.31,60.28 6.69,60.63  "
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M11.14,60.85c-0.48-0.27-1.25-0.28-1.73,0c-0.48,0.28-0.48,0.72,0,1c0.48,0.28,1.25,0.28,1.73,0 C11.61,61.57,11.61,61.13,11.14,60.85z M9.73,61.66c-0.3-0.17-0.3-0.45,0-0.62c0.3-0.17,0.78-0.17,1.08,0 c0.3,0.17,0.3,0.45,0,0.62C10.52,61.83,10.03,61.83,9.73,61.66z M13.66,60.85c-0.48,0.28-0.48,0.72,0,1 c0.48,0.28,1.25,0.28,1.73,0c0.48-0.27,0.48-0.72,0-1C14.91,60.58,14.14,60.58,13.66,60.85z M15.07,61.66 c-0.3,0.17-0.78,0.17-1.08,0c-0.3-0.17-0.3-0.45,0-0.62c0.3-0.17,0.78-0.17,1.08,0C15.36,61.21,15.36,61.49,15.07,61.66z  M12.17,59.82l0,3.06h0.46l0-3.06H12.17z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "20.79,61.33 10.44,67.3 10.44,67.7 20.79,61.72  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "10.44,67.3 9.48,66.75 9.48,67.14 10.44,67.69  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "3.07,63.05 2.11,62.49 2.11,62.89 3.07,63.44  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "24.42,59.23 21.04,61.18 21.04,61.57 24.42,59.62  "
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M111.34,50.66l-2.29-1.32c-0.68-0.39-2.36-0.72-3.72-0.72H50.89c-1.36,0-29.94,17.88-29.94,17.88 c-0.68,0.39-0.68,1.04,0,1.43l41.67,24.06c0.34,0.2,0.8,0.3,1.25,0.3l0,0h1.08l29.33-16.94l1.21-0.7h15.84V50.66z"
  })), /*#__PURE__*/React.createElement("g", null, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M92.62,72.64c0,0.79-0.56,1.11-1.24,0.72L49.72,49.3c-0.68-0.39-1.24-1.36-1.24-2.15V15.73 c0-0.79,0.56-1.11,1.24-0.72l41.67,24.06c0.68,0.39,1.24,1.36,1.24,2.15V72.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.1817,
    y1: 8.3799,
    x2: 96.3751,
    y2: 71.0688
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5757,
    style: {
      stopColor: "#6D6C93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6122,
    style: {
      stopColor: "#3D3E5D"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M92.32,38.53L50.65,14.47c-0.35-0.2-0.66-0.21-0.88-0.08v0l-0.89,0.52l0,0c0.22-0.11,0.51-0.08,0.84,0.1 l41.67,24.06c0.68,0.39,1.24,1.36,1.24,2.15v31.43c0,0.39-0.14,0.67-0.36,0.8v0l0.89-0.52l0,0c0.25-0.12,0.41-0.4,0.41-0.82V40.68 C93.56,39.89,93,38.92,92.32,38.53z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "91.38,71.43 49.72,47.38 49.72,16.44 91.38,40.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M63.13,90.22c-0.68,0.39-1.8,0.39-2.48,0L18.98,66.16c-0.68-0.39-0.68-1.04,0-1.43l28.4-16.4 c0.68-0.39,1.8-0.39,2.48,0l41.67,24.06c0.68,0.39,0.68,1.04,0,1.43L63.13,90.22z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "49.91,51.74 47.87,50.57 48.89,49.98 50.93,51.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "53.34,53.72 51.3,52.55 52.32,51.96 54.36,53.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "56.77,55.71 54.73,54.53 55.75,53.94 57.79,55.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "60.2,57.69 58.16,56.51 59.18,55.92 61.22,57.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "63.63,59.67 61.6,58.49 62.62,57.9 64.65,59.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "67.07,61.65 65.03,60.47 66.05,59.89 68.09,61.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "70.5,63.63 68.46,62.46 69.48,61.87 71.52,63.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "73.93,65.61 71.89,64.44 72.91,63.85 74.95,65.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "77.36,67.59 75.32,66.42 76.34,65.83 78.38,67.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "80.79,69.58 78.76,68.4 79.78,67.81 81.81,68.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "84.23,71.56 82.19,70.38 83.21,69.79 85.25,70.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "87.66,73.54 85.62,72.36 86.64,71.77 88.68,72.95  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "48.1,54.66 44.44,52.55 46.47,51.37 50.14,53.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "46.21,57.37 41.15,54.45 43.19,53.27 48.24,56.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "44.17,60.15 37.72,56.43 39.75,55.25 46.2,58.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "37.23,60.94 33.56,58.83 36.32,57.23 39.98,59.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "42.28,63.86 38.62,61.75 41.38,60.15 45.04,62.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "47.34,66.78 43.68,64.67 46.44,63.07 50.1,65.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "64.78,76.85 61.12,74.73 63.88,73.14 67.54,75.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "73.35,81.8 66.17,77.65 68.92,76.06 76.11,80.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "59.73,73.94 48.74,67.59 51.49,65.99 62.49,72.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "52.49,57.2 49.49,55.47 51.53,54.29 54.53,56.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "50.6,59.9 47.6,58.17 49.64,57 52.64,58.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "48.65,62.64 45.66,60.9 47.69,59.73 50.69,61.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "53.05,65.17 50.05,63.44 52.09,62.26 55.08,64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "57.44,67.71 54.44,65.98 56.48,64.8 59.48,66.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "61.83,70.24 58.83,68.51 60.87,67.34 63.87,69.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "66.22,72.78 63.23,71.05 65.26,69.87 68.26,71.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "70.62,75.32 67.62,73.58 69.65,72.41 72.65,74.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "77.6,79.35 72.01,76.12 74.05,74.94 79.64,78.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "54.99,62.44 51.99,60.71 54.03,59.53 57.03,61.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "59.38,64.98 56.38,63.24 58.42,62.07 61.42,63.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "63.77,67.51 60.78,65.78 62.81,64.6 65.81,66.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "68.17,70.05 65.17,68.32 67.21,67.14 70.2,68.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "72.56,72.58 69.56,70.85 71.6,69.68 74.6,71.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "80.94,77.42 73.95,73.39 75.99,72.21 82.97,76.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "56.89,59.74 53.89,58 55.92,56.83 58.92,58.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "61.28,62.27 58.28,60.54 60.32,59.36 63.32,61.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "65.67,64.81 62.67,63.08 64.71,61.9 67.71,63.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "70.06,67.34 67.06,65.61 69.1,64.44 72.1,66.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "74.45,69.88 71.46,68.15 73.49,66.97 76.49,68.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "78.85,72.41 75.85,70.68 77.89,69.51 80.88,71.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "84.23,75.52 80.24,73.22 82.28,72.04 86.26,74.34  "
  }))), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "86.17,70.44 53.24,51.43 54.23,50.86 87.16,69.86  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "59.73,76.39 42.93,66.69 32.49,72.72 49.29,82.42  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.4705,
    y1: 78.3492,
    x2: 92.0404,
    y2: 78.3492
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5618,
    style: {
      stopColor: "#61607F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    style: {
      stopColor: "#3D3E5D"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M91.53,73.82l-28.4,16.4c-0.54,0.31-1.36,0.38-2.01,0.19c-0.01,0-0.41-0.16-0.47-0.19L18.98,66.16 c-0.05-0.03-0.09-0.06-0.13-0.09c0,0,0,0-0.01-0.01h0c-0.01-0.01-0.02-0.02-0.03-0.02c-0.02-0.02-0.05-0.04-0.07-0.06 c-0.01-0.01-0.02-0.02-0.03-0.03c-0.03-0.03-0.05-0.05-0.07-0.08c0,0-0.01-0.01-0.01-0.01c0,0,0,0-0.01-0.01 c-0.02-0.03-0.05-0.06-0.06-0.1c-0.06-0.1-0.09-0.2-0.09-0.3h0v0.6h0c0,0.26,0.16,0.52,0.51,0.72l41.67,24.06 c0.99,0.49,2.41,0.4,2.84,0.3c0.42-0.09,0.8-0.2,1.25-0.3l26.8-15.47c0.34-0.2,0.52-0.46,0.51-0.73v-1.55 C92.04,73.37,91.87,73.63,91.53,73.82z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.1515,
    y1: 52.3552,
    x2: 52.7152,
    y2: 52.3552
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4C9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2101,
    style: {
      stopColor: "#D7DAED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    style: {
      stopColor: "#F4F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M47.38,48.33l-14.23,8.22h9.98l9.58-5.53l-4.94-2.85C47.63,48.21,47.5,48.26,47.38,48.33z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M49.72,16.44c0,0.33,0,3.81,0,4.14c2.28,1.31,39.39,22.74,41.67,24.06c0-0.33,0-3.81,0-4.14 C89.11,39.19,51.99,17.76,49.72,16.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M50.19,18.79c0-0.84,0.59-1.19,1.32-0.76c0.73,0.42,1.32,1.45,1.32,2.29c0,0.84-0.59,1.19-1.32,0.76 C50.78,20.66,50.19,19.63,50.19,18.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M51.7,19.59c0.08-0.03,0.13-0.13,0.13-0.28c0-0.24-0.14-0.52-0.32-0.63c-0.18-0.1-0.32,0.01-0.32,0.26 c0,0.15,0.05,0.3,0.13,0.43c-0.23-0.04-0.46,0.06-0.46,0.47c0.12,0.07,1.19,0.69,1.31,0.76C52.16,20.18,51.93,19.8,51.7,19.59z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "57.02,22.23 72.4,31.1 72.4,32.12 57.02,23.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "75.19,32.72 77.89,34.28 77.89,35.29 75.19,33.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "79.18,35.02 81.88,36.58 81.88,37.59 79.18,36.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "83.17,37.32 85.88,38.89 85.88,39.9 83.17,38.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "87.16,39.63 89.87,41.19 89.87,42.2 87.16,40.64  "
  }))), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "52.08,23.02 89.02,44.36 89.02,49.03 52.08,27.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.5648,
    y1: 67.7869,
    x2: 76.5648,
    y2: 36.3819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4C9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2878,
    style: {
      stopColor: "#E8EAF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5037,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "88,49.45 88,49.77 64.81,36.38 64.81,54.21 88.32,67.79 88.32,49.96  "
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "64.2,53.86 87.72,67.44 87.72,49.61 64.2,36.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "86.98,50.04 64.95,37.32 64.95,53.43 86.98,66.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "88,49.45 87.72,49.61 87.72,67.44 88,67.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "64.48,35.87 64.2,36.03 87.72,49.61 88,49.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "65.13,37.42 64.95,37.32 64.95,53.43 65.13,53.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "65.13,53.32 64.95,53.43 86.98,66.15 86.98,65.94  "
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M80.58,58.6c0-0.89,0.63-1.26,1.4-0.81c0.77,0.45,1.4,1.54,1.4,2.43c0,0.89-0.63,1.26-1.4,0.81 C81.21,60.58,80.58,59.49,80.58,58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M67.18,47.24c0-0.53,0.37-0.74,0.83-0.48c0.46,0.26,0.83,0.91,0.83,1.44c0,0.53-0.37,0.74-0.83,0.48 C67.55,48.41,67.18,47.77,67.18,47.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.63,53.57c0-0.37,0.26-0.52,0.58-0.33c0.32,0.18,0.58,0.63,0.58,1c0,0.37-0.26,0.52-0.58,0.33 C84.89,54.38,84.63,53.93,84.63,53.57z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "70.96,46.94 81.75,53.16 81.75,58.94 70.96,52.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "81.35,53.3 81.17,53.4 81.17,59.18 81.35,59.08  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M79.5,52.73l-3.75-5.87l-3.72,1.53l-0.06-0.14l3.78-1.55c0.03-0.01,0.07,0,0.09,0.03l3.78,5.92L79.5,52.73z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "70.57,47.07 70.39,47.18 81.17,53.4 81.35,53.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "70.39,47.18 81.17,53.4 81.17,59.18 70.39,52.95  "
  }))), /*#__PURE__*/React.createElement("g", null, _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "62.7,51.97 53.67,46.76 53.67,29.4 62.7,34.61  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "52.36,30.16 53.67,29.4 53.67,46.76 52.36,47.52  "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "52.36,47.52 53.67,46.76 62.7,51.97 61.39,52.73  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.1884,
    y1: 48.5069,
    x2: 60.4003,
    y2: 44.6757
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6427,
    style: {
      stopColor: "#F2F4FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "54.42,46.33 58.84,43.78 61.96,45.58 61.96,50.68  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "54.27,30.6 54.71,30.86 54.71,46.16 54.27,46.41  "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "54.42,30.69 54.57,30.77 54.56,46.25 54.42,46.33  "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "54.27,46.41 54.71,46.16 61.96,50.35 61.96,50.85  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "54.42,46.33 54.57,46.25 61.96,50.51 61.96,50.68  "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M54.42,30.69c0,1.48,0,14.16,0,15.64c1.14,0.66,6.4,3.69,7.54,4.35c0-1.48,0-14.16,0-15.64 C60.82,34.38,55.56,31.35,54.42,30.69z"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "61.39,35.37 62.7,34.61 62.7,51.97 61.39,52.73  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "52.36,30.16 53.67,29.4 62.7,34.61 61.39,35.37  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.4186,
    y1: 38.1962,
    x2: 61.9581,
    y2: 38.1962
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F4E6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0596,
    style: {
      stopColor: "#494866"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    style: {
      stopColor: "#22212F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8234,
    style: {
      stopColor: "#09090D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "54.42,45.71 61.96,37.02 61.96,35.04 54.42,30.69  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.8502,
    y1: 48.1293,
    x2: 61.9581,
    y2: 48.1293
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F4E6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0596,
    style: {
      stopColor: "#494866"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    style: {
      stopColor: "#22212F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8234,
    style: {
      stopColor: "#09090D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "56.85,47.73 61.96,45.58 61.96,50.68  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.3712,
    y1: 54.0221,
    x2: 88.3712,
    y2: 46.0667
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8EDF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    style: {
      stopColor: "#D9DEF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4C9E4"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M91.13,51.95l-2.11-5.89v3.15l-1.32,0.76l0,0l-2.1,1.21v0c0,0,0,0.01,0,0.01c0.12,0.13,0.25,0.23,0.39,0.31 c0.57,0.33,1.03,0.06,1.03-0.59c0,0.65,0.46,1.45,1.03,1.78c0.57,0.33,1.03,0.06,1.03-0.59c0,0.65,0.46,1.45,1.03,1.78 c0.57,0.33,1.03,0.06,1.03-0.59L91.13,51.95z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "85.06,51.51 89.02,49.22 89.02,46.07 85.06,50.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "50.16,30.03 48.11,28.84 52.08,24.74 54.13,25.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "52.21,31.21 50.16,30.03 54.13,25.92 56.18,27.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "54.27,32.4 52.21,31.21 56.18,27.11 58.23,28.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "56.32,33.58 54.27,32.4 58.23,28.29 60.29,29.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "58.37,34.77 56.32,33.58 60.29,29.48 62.34,30.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "60.42,35.95 58.37,34.77 62.34,30.66 64.39,31.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "62.48,37.14 60.42,35.95 64.39,31.85 66.45,33.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "64.53,38.32 62.48,37.14 66.45,33.03 68.5,34.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "66.58,39.51 64.53,38.32 68.5,34.22 70.55,35.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "68.63,40.69 66.58,39.51 70.55,35.4 72.6,36.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "70.69,41.88 68.63,40.69 72.6,36.59 74.66,37.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "72.74,43.06 70.69,41.88 74.66,37.77 76.71,38.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "74.79,44.25 72.74,43.06 76.71,38.96 78.76,40.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "76.84,45.43 74.79,44.25 78.76,40.14 80.81,41.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "78.9,46.62 76.84,45.43 80.81,41.33 82.87,42.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "80.95,47.8 78.9,46.62 82.87,42.51 84.92,43.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "83,48.99 80.95,47.8 84.92,43.7 86.97,44.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "85.06,50.17 83,48.99 86.97,44.88 89.02,46.07  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M48.11,28.84v1.34c0,0.65,0.46,1.45,1.03,1.78c0.57,0.33,1.03,0.06,1.03-0.59v-1.34L48.11,28.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M50.16,30.03v1.34c0,0.65,0.46,1.45,1.03,1.78c0.57,0.33,1.03,0.06,1.03-0.59v-1.34L50.16,30.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M52.21,31.21v1.34c0,0.65,0.46,1.45,1.03,1.78c0.57,0.33,1.03,0.06,1.03-0.59l0-1.34L52.21,31.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M54.27,32.4l0,1.34c0,0.65,0.46,1.45,1.03,1.78c0.57,0.33,1.03,0.06,1.03-0.59v-1.34L54.27,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M56.32,33.58v1.34c0,0.65,0.46,1.45,1.03,1.78c0.57,0.33,1.03,0.06,1.03-0.59v-1.34L56.32,33.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M58.37,34.77v1.34c0,0.65,0.46,1.45,1.03,1.78c0.57,0.33,1.03,0.06,1.03-0.59v-1.34L58.37,34.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M60.42,35.95v1.34c0,0.65,0.46,1.45,1.03,1.78c0.57,0.33,1.03,0.06,1.03-0.59v-1.34L60.42,35.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M62.48,37.14v1.34c0,0.65,0.46,1.45,1.03,1.78c0.57,0.33,1.03,0.06,1.03-0.59v-1.34L62.48,37.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M64.53,38.32v1.34c0,0.65,0.46,1.45,1.03,1.78c0.57,0.33,1.03,0.06,1.03-0.59l0-1.34L64.53,38.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M66.58,39.51l0,1.34c0,0.65,0.46,1.45,1.03,1.78c0.57,0.33,1.03,0.06,1.03-0.59v-1.34L66.58,39.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M68.63,40.69v1.34c0,0.65,0.46,1.45,1.03,1.78c0.57,0.33,1.03,0.06,1.03-0.59v-1.34L68.63,40.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M70.69,41.88v1.34c0,0.65,0.46,1.45,1.03,1.78c0.57,0.33,1.03,0.06,1.03-0.59v-1.34L70.69,41.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M72.74,43.06v1.34c0,0.65,0.46,1.45,1.03,1.78c0.57,0.33,1.03,0.06,1.03-0.59v-1.34L72.74,43.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M74.79,44.25v1.34c0,0.65,0.46,1.45,1.03,1.78c0.57,0.33,1.03,0.06,1.03-0.59v-1.34L74.79,44.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M76.84,45.43v1.34c0,0.65,0.46,1.45,1.03,1.78c0.57,0.33,1.03,0.06,1.03-0.59v-1.34L76.84,45.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M78.9,46.62v1.34c0,0.65,0.46,1.45,1.03,1.78c0.57,0.33,1.03,0.06,1.03-0.59V47.8L78.9,46.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M80.95,47.8v1.34c0,0.65,0.46,1.45,1.03,1.78c0.57,0.33,1.03,0.06,1.03-0.59v-1.34L80.95,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M83,48.99v1.34c0,0.65,0.46,1.45,1.03,1.78c0.57,0.33,1.03,0.06,1.03-0.59l0-1.34L83,48.99z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M71.37,19.16c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C71.34,19.45,71.3,19.29,71.37,19.16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M72.54,19.83c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C72.51,20.13,72.47,19.96,72.54,19.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M73.71,20.51c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C73.68,20.8,73.63,20.64,73.71,20.51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M74.88,21.18c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C74.85,21.47,74.8,21.31,74.88,21.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M76.04,21.85c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C76.01,22.15,75.97,21.98,76.04,21.85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M77.21,22.53c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C77.18,22.82,77.14,22.66,77.21,22.53z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M78.38,23.2c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C78.35,23.49,78.3,23.33,78.38,23.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M79.55,23.88c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C79.52,24.17,79.47,24,79.55,23.88z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M80.71,24.55c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C80.68,24.84,80.64,24.68,80.71,24.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M81.88,25.22c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C81.85,25.52,81.81,25.35,81.88,25.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M83.05,25.9c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C83.02,26.19,82.97,26.02,83.05,25.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M84.21,26.57c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C84.18,26.86,84.14,26.7,84.21,26.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M85.38,27.24c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C85.35,27.54,85.31,27.37,85.38,27.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M86.55,27.92c0.07-0.13,0.24-0.17,0.37-0.1s0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C86.52,28.21,86.47,28.05,86.55,27.92z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M87.72,28.59c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C87.69,28.88,87.64,28.72,87.72,28.59z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M88.88,29.26c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C88.85,29.56,88.81,29.39,88.88,29.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M90.05,29.94c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C90.02,30.23,89.98,30.07,90.05,29.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M91.22,30.61c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C91.19,30.9,91.14,30.74,91.22,30.61z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M92.39,31.29c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C92.36,31.58,92.31,31.41,92.39,31.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M93.55,31.96c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37s-0.24,0.17-0.37,0.1 S93.48,32.09,93.55,31.96z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M94.72,32.63c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 S94.65,32.76,94.72,32.63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M95.89,33.31c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C95.86,33.6,95.81,33.43,95.89,33.31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M97.05,33.98c0.07-0.13,0.24-0.17,0.37-0.1s0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 S96.98,34.11,97.05,33.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M98.22,34.65c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C98.19,34.95,98.15,34.78,98.22,34.65z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M99.39,35.33c0.07-0.13,0.24-0.17,0.37-0.1s0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 S99.31,35.46,99.39,35.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M100.56,36c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.07,0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 S100.48,36.13,100.56,36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M101.72,36.67c0.07-0.13,0.24-0.17,0.37-0.1s0.17,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C101.69,36.97,101.65,36.8,101.72,36.67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,38.38c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,38.5,102.88,38.38,103.02,38.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,37.25c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,37.37,102.88,37.25,103.02,37.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,39.71c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,39.83,102.88,39.71,103.02,39.71z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,41.04c0.15,0,0.27,0.12,0.27,0.27s-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 S102.88,41.04,103.02,41.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,42.38c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,42.5,102.88,42.38,103.02,42.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,43.71c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,43.83,102.88,43.71,103.02,43.71z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,45.04c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,45.16,102.88,45.04,103.02,45.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,46.37c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,46.49,102.88,46.37,103.02,46.37z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,47.71c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,47.83,102.88,47.71,103.02,47.71z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,49.04c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,49.16,102.88,49.04,103.02,49.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,50.37c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,50.49,102.88,50.37,103.02,50.37z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,51.7c0.15,0,0.27,0.12,0.27,0.27s-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 S102.88,51.7,103.02,51.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,53.03c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,53.15,102.88,53.03,103.02,53.03z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,54.37c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,54.49,102.88,54.37,103.02,54.37z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,55.7c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,55.82,102.88,55.7,103.02,55.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,57.03c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,57.15,102.88,57.03,103.02,57.03z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,58.36c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,58.48,102.88,58.36,103.02,58.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,59.7c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,59.82,102.88,59.7,103.02,59.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,61.03c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,61.15,102.88,61.03,103.02,61.03z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,62.36c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,62.48,102.88,62.36,103.02,62.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,63.69c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,63.81,102.88,63.69,103.02,63.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,65.02c0.15,0,0.27,0.12,0.27,0.27s-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 S102.88,65.02,103.02,65.02z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,66.36c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,66.48,102.88,66.36,103.02,66.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,67.69c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,67.81,102.88,67.69,103.02,67.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,69.02c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,69.14,102.88,69.02,103.02,69.02z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,70.35c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,70.47,102.88,70.35,103.02,70.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,71.69c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,71.81,102.88,71.69,103.02,71.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,73.02c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,73.14,102.88,73.02,103.02,73.02z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,74.35c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,74.47,102.88,74.35,103.02,74.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,75.68c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,75.8,102.88,75.68,103.02,75.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,77.01c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,77.13,102.88,77.01,103.02,77.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103.02,78.35c0.15,0,0.27,0.12,0.27,0.27c0,0.15-0.12,0.27-0.27,0.27c-0.15,0-0.27-0.12-0.27-0.27 C102.76,78.47,102.88,78.35,103.02,78.35z"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M16.63,77.73c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C16.6,78.03,16.56,77.86,16.63,77.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M17.81,78.41c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C17.78,78.71,17.73,78.54,17.81,78.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M18.99,79.09c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C18.96,79.39,18.91,79.22,18.99,79.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M20.16,79.77c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C20.13,80.07,20.09,79.9,20.16,79.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M21.34,80.45c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C21.31,80.75,21.27,80.58,21.34,80.45z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M22.52,81.13c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C22.49,81.43,22.44,81.26,22.52,81.13z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M23.69,81.82c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C23.66,82.11,23.62,81.94,23.69,81.82z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M24.87,82.5c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C24.84,82.79,24.8,82.62,24.87,82.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M26.05,83.18c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C26.02,83.47,25.97,83.3,26.05,83.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M27.22,83.86c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C27.2,84.15,27.15,83.98,27.22,83.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M28.4,84.54c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C28.37,84.83,28.33,84.66,28.4,84.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M29.58,85.22c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C29.55,85.51,29.5,85.34,29.58,85.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M30.76,85.9c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C30.73,86.19,30.68,86.02,30.76,85.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M31.93,86.58c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C31.9,86.87,31.86,86.7,31.93,86.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M33.11,87.26c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C33.08,87.55,33.04,87.38,33.11,87.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M34.29,87.94c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C34.26,88.23,34.21,88.06,34.29,87.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M35.46,88.62c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C35.44,88.91,35.39,88.74,35.46,88.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M36.64,89.3c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C36.61,89.59,36.57,89.43,36.64,89.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M37.82,89.98c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C37.79,90.27,37.74,90.11,37.82,89.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M39,90.66c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37s-0.24,0.17-0.37,0.1 C38.97,90.95,38.92,90.79,39,90.66z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M40.17,91.34c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C40.14,91.63,40.1,91.47,40.17,91.34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M41.35,92.02c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C41.32,92.31,41.27,92.15,41.35,92.02z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M42.53,92.7c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C42.5,92.99,42.45,92.83,42.53,92.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M43.7,93.38c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C43.67,93.67,43.63,93.51,43.7,93.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M44.88,94.06c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C44.85,94.35,44.81,94.19,44.88,94.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M46.06,94.74c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C46.03,95.03,45.98,94.87,46.06,94.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M47.23,95.42c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C47.21,95.71,47.16,95.55,47.23,95.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M48.41,96.1c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C48.38,96.39,48.34,96.23,48.41,96.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M49.59,96.78c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C49.56,97.07,49.51,96.91,49.59,96.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M50.77,97.46c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C50.74,97.75,50.69,97.59,50.77,97.46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M51.94,98.14c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C51.91,98.43,51.87,98.27,51.94,98.14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M53.12,98.82c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C53.09,99.11,53.05,98.95,53.12,98.82z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M54.3,99.5c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C54.27,99.79,54.22,99.63,54.3,99.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M55.47,100.18c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C55.44,100.47,55.4,100.31,55.47,100.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M56.65,100.86c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C56.62,101.15,56.58,100.99,56.65,100.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M57.83,101.54c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C57.8,101.83,57.75,101.67,57.83,101.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M59,102.22c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C58.98,102.51,58.93,102.35,59,102.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M60.18,102.9c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C60.15,103.19,60.11,103.03,60.18,102.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M61.32,103.52c0.07-0.13,0.24-0.17,0.37-0.1c0.13,0.08,0.18,0.24,0.1,0.37c-0.07,0.13-0.24,0.17-0.37,0.1 C61.29,103.82,61.25,103.65,61.32,103.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M62.33,103.18c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C62.56,103.35,62.4,103.31,62.33,103.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M63.49,102.51c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C63.73,102.68,63.56,102.63,63.49,102.51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M64.65,101.83c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C64.89,102.01,64.73,101.96,64.65,101.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M65.81,101.16c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C66.05,101.34,65.89,101.29,65.81,101.16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M66.98,100.49c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C67.22,100.66,67.05,100.62,66.98,100.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M68.14,99.82c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C68.38,99.99,68.21,99.95,68.14,99.82z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M69.3,99.15c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C69.54,99.32,69.38,99.28,69.3,99.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M70.47,98.48c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C70.7,98.65,70.54,98.61,70.47,98.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M71.63,97.81c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C71.87,97.98,71.7,97.93,71.63,97.81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M72.79,97.13c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C73.03,97.31,72.87,97.26,72.79,97.13z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M73.95,96.46c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C74.19,96.64,74.03,96.59,73.95,96.46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M75.12,95.79c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C75.36,95.96,75.19,95.92,75.12,95.79z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M76.28,95.12c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C76.52,95.29,76.35,95.25,76.28,95.12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M77.44,94.45c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C77.68,94.62,77.52,94.58,77.44,94.45z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M78.61,93.78c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C78.84,93.95,78.68,93.91,78.61,93.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M79.77,93.11c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C80.01,93.28,79.84,93.24,79.77,93.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M80.93,92.44c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C81.17,92.61,81.01,92.56,80.93,92.44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M82.09,91.76c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C82.33,91.94,82.17,91.89,82.09,91.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M83.26,91.09c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C83.49,91.27,83.33,91.22,83.26,91.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M84.42,90.42c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C84.66,90.59,84.49,90.55,84.42,90.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M85.58,89.75c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C85.82,89.92,85.66,89.88,85.58,89.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M86.74,89.08c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C86.98,89.25,86.82,89.21,86.74,89.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M87.91,88.41c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C88.15,88.58,87.98,88.54,87.91,88.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M89.07,87.74c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C89.31,87.91,89.14,87.86,89.07,87.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M90.23,87.06c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C90.47,87.24,90.31,87.19,90.23,87.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M91.4,86.39c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C91.63,86.57,91.47,86.52,91.4,86.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M92.56,85.72c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C92.8,85.89,92.63,85.85,92.56,85.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M93.72,85.05c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C93.96,85.22,93.8,85.18,93.72,85.05z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M94.88,84.38c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C95.12,84.55,94.96,84.51,94.88,84.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M96.05,83.71c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C96.29,83.88,96.12,83.84,96.05,83.71z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M97.21,83.04c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C97.45,83.21,97.28,83.16,97.21,83.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M98.37,82.36c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C98.61,82.54,98.45,82.49,98.37,82.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M99.54,81.69c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C99.77,81.87,99.61,81.82,99.54,81.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M100.7,81.02c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C100.94,81.19,100.77,81.15,100.7,81.02z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M101.86,80.35c-0.07-0.13-0.03-0.29,0.1-0.37c0.13-0.07,0.29-0.03,0.37,0.1c0.07,0.13,0.03,0.29-0.1,0.37 C102.1,80.52,101.94,80.48,101.86,80.35z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.7306,
    y1: 77.0094,
    x2: 19.918,
    y2: 77.0094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4265,
    style: {
      stopColor: "#C4CAE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5766,
    style: {
      stopColor: "#D7DBF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8459,
    style: {
      stopColor: "#F4F5FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M18.79,75.44c-0.8-0.46-1.87-0.68-2.91-0.64h-1.17v0.27c-0.31,0.1-0.6,0.22-0.87,0.38 c-1.49,0.87-1.48,2.27,0.02,3.14c0.26,0.15,0.55,0.27,0.85,0.37v0.28h1.49c0.95-0.02,1.88-0.23,2.6-0.65 C20.3,77.71,20.29,76.31,18.79,75.44z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.042,
    y1: 77.7109,
    x2: 18.7047,
    y2: 77.7109
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D8DEF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    style: {
      stopColor: "#C6CCE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BDC3E3"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M12.17,78.58c-0.76-0.44-1.13-1.01-1.13-1.58l0-0.8c0,0.57,0.38,1.14,1.13,1.58c1.5,0.87,3.93,0.87,5.42,0 c0.74-0.43,1.11-0.99,1.11-1.56l0,0.8c0,0.56-0.37,1.13-1.11,1.56C16.1,79.44,13.67,79.44,12.17,78.58z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M12.18,77.77c-1.5-0.87-1.51-2.27-0.02-3.14c1.49-0.87,3.92-0.87,5.42,0c1.5,0.87,1.51,2.27,0.02,3.14 C16.1,78.64,13.68,78.64,12.18,77.77z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M15.06,77.2c-0.1-0.06-0.24-0.09-0.38-0.09l-0.59-1.24c0.07-0.02,0.14-0.05,0.21-0.08 c0.08-0.05,0.14-0.1,0.18-0.16l1.84,0.17c0.01,0.07,0.06,0.13,0.15,0.19c0.21,0.12,0.54,0.12,0.74,0c0.21-0.12,0.21-0.31,0-0.43 c-0.21-0.12-0.54-0.12-0.74,0c-0.05,0.03-0.08,0.06-0.11,0.09l-1.84-0.17c0-0.11-0.08-0.21-0.22-0.29c-0.29-0.17-0.76-0.17-1.05,0 c-0.29,0.17-0.29,0.44,0,0.61c0.16,0.09,0.38,0.14,0.59,0.12l0.59,1.24c-0.04,0.01-0.08,0.03-0.11,0.05 c-0.21,0.12-0.21,0.31,0,0.43c0.21,0.12,0.54,0.12,0.74,0C15.26,77.51,15.26,77.32,15.06,77.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 586.0337,
    y1: 70.5999,
    x2: 590.4517,
    y2: 62.9478,
    gradientTransform: "matrix(-1 0 0 1 692.75 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BDC3E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8426,
    style: {
      stopColor: "#DBDFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E1E5F1"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M103.81,63.58c-0.87-0.5-1.66-0.55-2.23-0.22l-0.78,0.45c0.57-0.33,1.36-0.28,2.23,0.22 c1.73,1,3.13,3.42,3.12,5.41c0,0.99-0.35,1.68-0.91,2.01l0.78-0.45c0.56-0.33,0.91-1.02,0.91-2.01 C106.94,67,105.54,64.58,103.81,63.58z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M103.02,64.04c-1.73-1-3.14-0.2-3.14,1.79c-0.01,1.99,1.39,4.41,3.12,5.41c1.73,1,3.14,0.2,3.14-1.79 C106.15,67.46,104.76,65.04,103.02,64.04z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M104.07,66.78c-0.59-1.02-1.54-1.57-2.13-1.23c-0.59,0.34-0.59,1.44,0,2.46l1.06,1.84l1.06-0.61 C104.66,68.9,104.66,67.8,104.07,66.78z M103,68.22c-0.39-0.23-0.71-0.78-0.71-1.23c0-0.45,0.32-0.64,0.71-0.41 c0.39,0.23,0.71,0.78,0.71,1.23C103.71,68.26,103.4,68.44,103,68.22z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.8812,
    y1: 85.1793,
    x2: 34.0684,
    y2: 85.1793
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4265,
    style: {
      stopColor: "#C4CAE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5766,
    style: {
      stopColor: "#D7DBF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8459,
    style: {
      stopColor: "#F4F5FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M32.94,83.61c-0.8-0.46-1.86-0.68-2.91-0.64h-1.17v0.27c-0.31,0.1-0.6,0.22-0.87,0.38 c-1.49,0.87-1.48,2.27,0.02,3.14c0.26,0.15,0.55,0.27,0.85,0.37v0.28h1.49c0.94-0.02,1.88-0.23,2.6-0.65 C34.45,85.88,34.44,84.48,32.94,83.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.1923,
    y1: 85.8806,
    x2: 32.8555,
    y2: 85.8806
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D8DEF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    style: {
      stopColor: "#C6CCE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BDC3E3"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M26.32,86.75c-0.76-0.44-1.13-1.01-1.13-1.58l0-0.8c0,0.57,0.38,1.14,1.13,1.58c1.5,0.87,3.93,0.87,5.42,0 c0.74-0.43,1.11-0.99,1.11-1.56l0,0.8c0,0.56-0.37,1.13-1.11,1.56C30.25,87.61,27.82,87.61,26.32,86.75z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M26.33,85.94c-1.5-0.87-1.51-2.27-0.02-3.14c1.49-0.87,3.92-0.87,5.42,0c1.5,0.87,1.51,2.27,0.02,3.14 C30.25,86.81,27.83,86.81,26.33,85.94z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M29.67,83.65c-0.03-0.11-0.12-0.22-0.27-0.31c-0.38-0.22-1-0.22-1.38,0c-0.19,0.11-0.29,0.25-0.29,0.4v1.36 l2.35,0c0.25,0,0.5-0.05,0.69-0.16c0.38-0.22,0.38-0.58,0-0.8c-0.15-0.09-0.34-0.14-0.53-0.16l-0.52-0.03L29.67,83.65z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 586.0337,
    y1: 53.7776,
    x2: 590.4517,
    y2: 46.1255,
    gradientTransform: "matrix(-1 0 0 1 692.75 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BDC3E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8426,
    style: {
      stopColor: "#DBDFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E1E5F1"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M103.81,46.76c-0.87-0.5-1.66-0.55-2.23-0.22L100.79,47c0.57-0.33,1.36-0.28,2.23,0.22 c1.73,1,3.13,3.42,3.12,5.41c0,0.99-0.35,1.68-0.91,2.01l0.78-0.45c0.56-0.33,0.91-1.02,0.91-2.01 C106.94,50.18,105.54,47.76,103.81,46.76z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M103.02,47.21c-1.73-1-3.14-0.2-3.14,1.79c-0.01,1.99,1.39,4.41,3.12,5.41c1.73,1,3.14,0.2,3.14-1.79 C106.15,50.64,104.76,48.21,103.02,47.21z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M102.99,50.53c-0.27-0.16-0.5-0.55-0.5-0.86c0-0.32,0.22-0.45,0.5-0.29c0.28,0.16,0.5,0.55,0.5,0.86 l0.36,0.21c0-0.48-0.29-1.04-0.68-1.36l0-0.37l-0.36-0.21v0.37c-0.39-0.13-0.68,0.1-0.68,0.58c0,0.55,0.39,1.22,0.86,1.49 c0.13,0.08,0.26,0.21,0.35,0.37c0.09,0.16,0.15,0.34,0.15,0.49c0,0.15-0.05,0.27-0.15,0.32c-0.09,0.05-0.22,0.04-0.35-0.03 c-0.28-0.16-0.5-0.55-0.5-0.86l-0.36-0.21c0,0.48,0.29,1.04,0.68,1.36v0.37l0.36,0.21V52.6c0.16,0.05,0.31,0.05,0.43-0.02 c0.16-0.09,0.25-0.29,0.25-0.56c0-0.27-0.09-0.57-0.25-0.85C103.44,50.89,103.22,50.66,102.99,50.53z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 618.4874,
    y1: 22.0802,
    x2: 622.9053,
    y2: 14.4282,
    gradientTransform: "matrix(-1 0 0 1 692.75 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BDC3E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8426,
    style: {
      stopColor: "#DBDFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E1E5F1"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M71.35,15.06c-0.87-0.5-1.66-0.55-2.23-0.22l-0.78,0.45c0.57-0.33,1.36-0.28,2.23,0.22 c1.73,1,3.13,3.42,3.12,5.41c0,0.99-0.35,1.68-0.91,2.01l0.78-0.45c0.56-0.33,0.91-1.02,0.91-2.01 C74.48,18.48,73.08,16.06,71.35,15.06z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M70.57,15.52c-1.73-1-3.14-0.2-3.14,1.79c-0.01,1.99,1.39,4.41,3.12,5.41c1.73,1,3.14,0.2,3.14-1.79 C73.7,18.94,72.3,16.52,70.57,15.52z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M71.25,18.14c-0.54-0.94-1.42-1.45-1.96-1.13c-0.54,0.31-0.54,1.33,0,2.27c0.49,0.86,1.27,1.35,1.82,1.19 l0.79,1.37c0.08,0.13,0.2,0.2,0.27,0.16c0.08-0.04,0.08-0.19,0-0.32l-0.79-1.37C71.78,19.91,71.74,18.99,71.25,18.14z  M70.97,19.93c-0.39,0.23-1.02-0.14-1.41-0.82c-0.39-0.68-0.39-1.41,0-1.63c0.39-0.23,1.02,0.14,1.41,0.82 C71.36,18.97,71.36,19.7,70.97,19.93z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 597.6544,
    y1: 34.1083,
    x2: 602.0723,
    y2: 26.4563,
    gradientTransform: "matrix(-1 0 0 1 692.75 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BDC3E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8426,
    style: {
      stopColor: "#DBDFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E1E5F1"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M92.19,27.09c-0.87-0.5-1.66-0.55-2.23-0.22l-0.78,0.45c0.57-0.33,1.36-0.28,2.23,0.22 c1.73,1,3.13,3.42,3.12,5.41c0,0.99-0.35,1.68-0.91,2.01l0.78-0.45c0.56-0.33,0.91-1.02,0.91-2.01 C95.31,30.51,93.92,28.09,92.19,27.09z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M91.4,27.55c-1.73-1-3.14-0.2-3.14,1.79c-0.01,1.99,1.39,4.41,3.12,5.41c1.73,1,3.14,0.2,3.14-1.79 C94.53,30.97,93.13,28.54,91.4,27.55z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M92.6,31.59l-0.27,0.78l-1.82-1.05l-0.45-1.85l-0.03-0.12l-0.5-0.29v0.3l0.31,0.18l0.45,1.85l0.03,0.12 l2.2,1.27l0.03-0.09l0.3-0.86L92.6,31.59z M92.15,32.76c-0.15-0.09-0.27-0.02-0.27,0.16c0,0.17,0.12,0.39,0.27,0.47 c0.15,0.09,0.27,0.02,0.27-0.16C92.43,33.06,92.31,32.85,92.15,32.76z M90.72,31.93c-0.15-0.09-0.27-0.02-0.27,0.16 c0,0.17,0.12,0.39,0.27,0.47c0.15,0.09,0.27,0.02,0.27-0.16C90.99,32.23,90.87,32.02,90.72,31.93z M92.02,31.12l-0.18-0.32 l-0.33,0.19v-1.3l-0.26-0.15v1.3l-0.33-0.57l-0.18,0.11l0.65,1.12L92.02,31.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.4804,
    y1: 32.0089,
    x2: 39.4804,
    y2: 12.408
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD69B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1562,
    style: {
      stopColor: "#FFE0B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4385,
    style: {
      stopColor: "#FFF1DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6622,
    style: {
      stopColor: "#FFFBF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7978,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "42.86,27.91 36.1,32.01 36.1,16.5 42.86,12.41  "
  })), /*#__PURE__*/React.createElement("g", null, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M37.79,32.06c0-1.69,1.19-3.74,2.65-4.59c1.46-0.84,2.65-0.16,2.65,1.53c0,1.69-1.19,3.74-2.65,4.59 C38.97,34.43,37.79,33.75,37.79,32.06z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M40.66,26.76c-1.87,1.08-3.38,3.7-3.38,5.85c0,2.16,1.51,3.03,3.38,1.95c1.87-1.08,3.38-3.7,3.38-5.85 C44.04,26.56,42.53,25.68,40.66,26.76z M40.66,33.72c-1.46,0.84-2.65,0.16-2.65-1.53c0-1.69,1.19-3.74,2.65-4.59 c1.46-0.84,2.65-0.16,2.65,1.53C43.31,30.82,42.12,32.88,40.66,33.72z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.669,
    y1: 34.4133,
    x2: 43.4129,
    y2: 27.9287
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FB944B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0156,
    style: {
      stopColor: "#FA934B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5021,
    style: {
      stopColor: "#EB7A3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7978,
    style: {
      stopColor: "#E57139"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M42.42,27.36c0.41,0.3,0.67,0.86,0.67,1.64c0,1.69-1.19,3.74-2.65,4.59c-0.67,0.39-1.29,0.45-1.76,0.24 c0.48,0.35,1.19,0.34,1.98-0.11c1.46-0.84,2.65-2.9,2.65-4.59C43.31,28.22,42.96,27.61,42.42,27.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.4678,
    y1: 33.7602,
    x2: 41.2466,
    y2: 25.4832
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E57139"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3937,
    style: {
      stopColor: "#EE874B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFAF6D"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M41.92,25.88c-0.62-0.39-1.48-0.35-2.44,0.2c-1.87,1.08-3.38,3.7-3.38,5.85c0,1.09,0.39,1.86,1.02,2.2l0,0 l1.08,0.62c-0.57-0.37-0.91-1.11-0.91-2.14c0-2.16,1.51-4.78,3.38-5.85c0.91-0.53,1.74-0.59,2.35-0.26L41.92,25.88L41.92,25.88z"
  }))), /*#__PURE__*/React.createElement("g", null, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M40.66,30.42c-0.13,0.08-0.26,0.09-0.36,0.04c-0.09-0.05-0.15-0.17-0.15-0.32c0-0.32,0.23-0.71,0.5-0.87 c0.28-0.16,0.5-0.03,0.5,0.29l0.46-0.26c0-0.52-0.31-0.77-0.73-0.65l0-0.41l-0.46,0.26v0.41c-0.42,0.36-0.73,0.97-0.73,1.49 c0,0.3,0.1,0.51,0.28,0.62c0.18,0.1,0.42,0.08,0.68-0.07c0.28-0.16,0.5-0.03,0.5,0.29c0,0.32-0.23,0.71-0.5,0.87 c-0.28,0.16-0.5,0.03-0.5-0.29l-0.46,0.26c0,0.52,0.31,0.77,0.73,0.65l0,0.38l0.46-0.26v-0.38c0.42-0.36,0.73-0.97,0.73-1.49 C41.62,30.36,41.19,30.11,40.66,30.42z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M40.89,29.19c0.03,0.06,0.05,0.13,0.05,0.23l0.23,0.13C41.16,29.32,41.05,29.19,40.89,29.19z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M41.16,30.25c-0.18-0.13-0.43-0.13-0.72,0.04c-0.08,0.05-0.15,0.07-0.22,0.07c0.02,0.04,0.05,0.08,0.09,0.1 c0.1,0.05,0.22,0.04,0.36-0.04c0.26-0.15,0.49-0.17,0.66-0.08L41.16,30.25L41.16,30.25z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M40.89,30.87c0.03,0.06,0.05,0.13,0.05,0.23c0,0.32-0.23,0.71-0.5,0.87c-0.08,0.05-0.16,0.07-0.22,0.07 c0.08,0.14,0.25,0.18,0.45,0.06c0.28-0.16,0.5-0.55,0.5-0.87C41.16,31,41.05,30.87,40.89,30.87z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M40.21,32.75v0.22l0.23,0.13l0-0.38C40.35,32.75,40.28,32.76,40.21,32.75z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M40.89,28.48v0.16c0.16-0.05,0.3-0.04,0.42,0.01l-0.17-0.1l0,0C41.07,28.5,40.98,28.48,40.89,28.48z"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "40.66,28.09 40.21,28.35 40.43,28.48 40.89,28.22  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.5218,
    y1: 30.7437,
    x2: 40.5484,
    y2: 28.9655
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E57139"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0196,
    style: {
      stopColor: "#E67239"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6293,
    style: {
      stopColor: "#F58B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB944B"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M39.48,30.26c0,0.3,0.1,0.51,0.28,0.62L39.96,31c-0.17-0.11-0.26-0.32-0.26-0.6c0-0.52,0.31-1.13,0.73-1.49 l-0.23-0.13C39.79,29.13,39.48,29.74,39.48,30.26z"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "40.21,28.35 40.21,28.77 40.43,28.9 40.43,28.48  "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M39.7,32.07l-0.23-0.13c0,0.28,0.09,0.48,0.24,0.59c0,0,0,0,0,0l0,0c0.03,0.02,0.06,0.04,0.09,0.05 l0.13,0.08C39.79,32.55,39.7,32.35,39.7,32.07z"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "40.16,31.81 39.93,31.68 39.48,31.94 39.7,32.07  "
  })))), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "57.15,92.8 47.48,92.8 53.34,96.18 47.48,99.57 57.15,99.57 63,96.18  "
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "48.89,89.78 54.75,93.17 53.34,90.6 47.48,87.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "46.06,89.78 40.2,93.17 41.62,90.6 47.48,87.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "41.62,96.18 47.48,99.57 47.48,93.99 41.62,90.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "41.62,94.02 47.48,97.4 47.48,93.99 41.62,90.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "40.62,94.18 46.48,97.56 47.48,93.99 41.62,90.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "53.34,96.18 47.48,99.57 47.48,93.99 53.34,90.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "54.33,94.18 48.48,97.56 47.48,93.99 53.34,90.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "47.48,87.22 47.48,93.98 53.34,90.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "41.62,90.6 47.48,93.99 47.48,93.98 47.48,87.22  "
  }))), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "47.47,92.8 46.45,93.39 47.48,93.99 48.5,93.39  "
  })), /*#__PURE__*/React.createElement("g", null, _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "49.48,90.12 47.48,93.12 51.49,88.11  "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "43.47,88.11 47.48,93.12 45.47,90.12  "
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "45.47,90.12 47.48,93.12 49.48,90.12  "
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "45.47,90.12 43.47,88.11 45.47,86.11 49.48,86.11 51.49,88.11 49.48,90.12  "
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "46.32,88.06 45.16,86.89 46.32,85.73 48.64,85.73 49.8,86.89 48.64,88.06  "
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "45.47,90.12 46.32,88.06 48.64,88.06 49.48,90.12  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.4778,
    y1: 85.7337,
    x2: 47.4778,
    y2: 87.2747
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8EDF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    style: {
      stopColor: "#F6F8FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "45.47,87.27 46.32,85.73 48.64,85.73 49.48,87.27  "
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "45.16,86.89 43.47,88.11 45.47,90.12 46.32,88.06  "
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "43.47,88.11 45.16,86.89 46.32,85.73 45.47,86.11  "
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "49.8,86.89 51.49,88.11 49.48,90.12 48.64,88.06  "
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "51.49,88.11 49.8,86.89 48.64,85.73 49.48,86.11  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.4655,
    y1: 87.5043,
    x2: 46.3166,
    y2: 87.5043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8EDF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1406,
    style: {
      stopColor: "#BDC1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377,
    style: {
      stopColor: "#7B7D84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5898,
    style: {
      stopColor: "#46474B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    style: {
      stopColor: "#202122"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9136,
    style: {
      stopColor: "#090909"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "43.47,88.11 46.29,88.11 46.32,88.06 45.16,86.89  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.1075,
    y1: 89.1171,
    x2: 439.9344,
    y2: 89.1171,
    gradientTransform: "matrix(-1 0 0 1 488.5977 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8EDF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0299,
    style: {
      stopColor: "#DEE3EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2332,
    style: {
      stopColor: "#A0A5AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4268,
    style: {
      stopColor: "#6D7178"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6055,
    style: {
      stopColor: "#45494D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7662,
    style: {
      stopColor: "#282C2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9031,
    style: {
      stopColor: "#161A1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#101416"
    }
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "51.49,88.11 48.66,88.11 49.48,90.12  "
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M109.02,92.87v-8.73H96.59l-1.09,0.63h-1.42l-11.9,6.87l-1.55,0.89c-0.83,0.48-2.84,0.87-4.5,0.87l-0.49,0.28 h-0.53l-1.83,1.06l7.56,4.37h2.7l0,0h0.53h4.15l8.42-1.3h0.96l3.11-1.79h0l0,0l-1.29-0.75h5.46L109.02,92.87z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M81.48,97.39c-0.24-0.14-0.39-0.44-0.39-0.87c0-0.86,0.6-1.9,1.35-2.33c0.37-0.21,0.71-0.24,0.95-0.09 c0.24,0.14,0.39,0.44,0.39,0.87c0,0.86-0.6,1.9-1.35,2.33C82.06,97.51,81.72,97.53,81.48,97.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M81.69,96.17c0-0.47,0.33-1.05,0.74-1.28c0.41-0.24,0.74-0.04,0.74,0.43c0,0.47-0.33,1.05-0.74,1.28 C82.02,96.83,81.69,96.64,81.69,96.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M81.08,96.52c0-0.86,0.6-1.9,1.35-2.33c0.37-0.21,0.71-0.24,0.95-0.09l-1.03-0.6 c-0.24-0.14-0.58-0.12-0.95,0.09c-0.74,0.43-1.35,1.47-1.35,2.33c0,0.43,0.15,0.73,0.39,0.87l1.03,0.6 C81.23,97.25,81.08,96.95,81.08,96.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M92.39,91.09C92.15,90.94,92,90.64,92,90.21c0-0.86,0.6-1.9,1.35-2.33c0.37-0.21,0.71-0.24,0.95-0.09 c0.24,0.14,0.39,0.44,0.39,0.87c0,0.86-0.6,1.9-1.35,2.33C92.97,91.21,92.64,91.23,92.39,91.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M92.6,89.86c0-0.47,0.33-1.05,0.74-1.28c0.41-0.24,0.74-0.04,0.74,0.43c0,0.47-0.33,1.05-0.74,1.28 C92.94,90.53,92.6,90.34,92.6,89.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M92,90.21c0-0.86,0.6-1.9,1.35-2.33c0.37-0.21,0.71-0.24,0.95-0.09l-1.03-0.6 c-0.24-0.14-0.58-0.12-0.95,0.09c-0.74,0.43-1.35,1.47-1.35,2.33c0,0.43,0.15,0.73,0.39,0.87l1.03,0.6 C92.15,90.94,92,90.64,92,90.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M89.46,92.78c-0.24-0.14-0.39-0.44-0.39-0.87c0-0.86,0.6-1.9,1.35-2.33c0.37-0.21,0.71-0.24,0.95-0.09 c0.24,0.14,0.39,0.44,0.39,0.87c0,0.86-0.6,1.9-1.35,2.33C90.04,92.9,89.7,92.92,89.46,92.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M89.67,91.56c0-0.47,0.33-1.05,0.74-1.28c0.41-0.24,0.74-0.04,0.74,0.43c0,0.47-0.33,1.05-0.74,1.28 C90,92.22,89.67,92.03,89.67,91.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M89.07,91.91c0-0.86,0.6-1.9,1.35-2.33c0.37-0.21,0.71-0.24,0.95-0.09l-1.03-0.6 c-0.24-0.14-0.58-0.12-0.95,0.09c-0.74,0.43-1.35,1.47-1.35,2.33c0,0.43,0.15,0.73,0.39,0.87l1.03,0.6 C89.22,92.64,89.07,92.34,89.07,91.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "96.11,85.21 84.2,92.08 77.23,88.06 89.14,81.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "96.11,86.37 84.2,93.24 84.2,92.08 96.11,85.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "84.2,93.24 77.23,89.22 77.23,88.06 84.2,92.08  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "97.19,77.74 85.49,84.5 77.93,80.13 89.63,73.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "94.05,75.92 82.35,82.68 81.08,81.95 92.78,75.19  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "97.19,84.92 85.49,91.68 85.49,84.5 97.19,77.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "85.49,91.68 77.93,87.31 77.93,80.13 85.49,84.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "96.53,84.03 96.22,84.57 96.22,83.39 96.02,83.5 96.02,84.68 95.71,84.5 95.58,84.74 96.12,85.06  96.67,84.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "95.14,84.83 94.83,85.37 94.83,84.19 94.64,84.3 94.64,85.49 94.33,85.3 94.19,85.54 94.73,85.86  95.28,84.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "88.54,83.8 86.15,85.18 86.15,84.84 88.54,83.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "87.68,85.04 86.15,85.93 86.15,85.58 87.68,84.7  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "82.35,82.68 82.35,84.26 81.08,83.53 81.08,81.95  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M83.98,93.11l0-6.34l-3.11,1.79v0.55l-2.26,4.86v2.4v1.56l2.32-1.34c0-0.96,0.67-2.12,1.5-2.6L83.98,93.11 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "83.49,91.17 78.97,93.78 81.23,88.92 83.49,87.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "83.49,92.86 81.04,94.27 81.04,92.58 83.49,91.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "81.32,88.86 81.23,88.92 81.04,89.31 81.04,92.58 81.32,92.42  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "80.87,88.57 74.34,84.8 77.45,83.01 83.98,86.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "74.34,85.35 80.87,89.12 80.87,88.57 74.34,84.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M78.32,93.81c-1.98-1.14-3.96-2.29-5.94-3.43c0.75-1.62,1.51-3.24,2.26-4.86 c1.98,1.14,3.96,2.29,5.94,3.43C79.83,90.57,79.07,92.19,78.32,93.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M78.32,93.81c0.12,0.07,0.18,0.1,0.29,0.17c0.75-1.62,1.51-3.24,2.26-4.86c-0.12-0.07-0.18-0.1-0.29-0.17 C79.83,90.57,79.07,92.19,78.32,93.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M72.09,90.22c0.12,0.07,0.18,0.1,0.29,0.17c0.75-1.62,1.51-3.24,2.26-4.86c-0.12-0.07-0.18-0.1-0.29-0.17 C73.59,86.98,72.84,88.6,72.09,90.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "78.61,93.98 78.61,97.94 72.09,94.17 72.09,90.22  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M76.89,94.2v1.18l-3.07-1.77v-1.18c0-0.25,0.18-0.35,0.4-0.23l2.28,1.32 C76.71,93.65,76.89,93.95,76.89,94.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "78.32,95.37 77.18,94.71 77.18,94.2 78.32,94.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "78.32,95.96 77.75,95.63 77.75,95.37 78.32,95.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "72.38,92.53 72.95,92.85 72.95,92.6 72.38,92.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "72.38,91.94 73.52,92.59 73.52,92.08 72.38,91.42  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "78.61,96.69 80.44,95.63 80.44,97.19 78.61,98.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "71.56,92.61 78.61,96.69 78.61,98.25 71.56,94.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "72.09,92.31 71.56,92.61 78.61,96.69 80.44,95.63 80.18,95.48 78.61,96.38 72.09,92.61  "
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.3806,
    y1: 88.732,
    x2: 80.3971,
    y2: 88.732
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D8DEF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3093,
    style: {
      stopColor: "#989CA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M79.63,88.41l-6.25,2.55c0.22,0.13,0.44,0.25,0.66,0.38l6.25-2.55C80.07,88.66,79.85,88.53,79.63,88.41z  M74.64,91.69c0.14,0.08,0.29,0.17,0.43,0.25l5.08-2.07c0.08-0.18,0.16-0.35,0.24-0.52L74.64,91.69z M74.64,85.52 c-0.75,1.62-1.51,3.24-2.26,4.86l6.25-2.55C77.3,87.06,75.97,86.29,74.64,85.52z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.698,
    y1: 79.567,
    x2: 31.6813,
    y2: 79.567
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4CAE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    style: {
      stopColor: "#CED3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4088,
    style: {
      stopColor: "#E9EBF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6869,
    style: {
      stopColor: "#F9FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8989,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "31.68,78.93 25.46,78.93 24.7,80.21 31.68,80.21  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.5246,
    y1: 77.643,
    x2: 33.5079,
    y2: 77.643
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4CAE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    style: {
      stopColor: "#CED3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4088,
    style: {
      stopColor: "#E9EBF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6869,
    style: {
      stopColor: "#F9FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8989,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "33.51,77.23 27.29,77.23 26.52,78.05 33.51,78.05  "
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "25.01,73.56 22.51,75 22.35,71.07 24.85,69.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "22.51,75 21.95,74.69 22.11,70.93 22.23,71 22.35,71.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "22.11,70.93 22.35,71.07 24.61,69.77 24.61,69.49  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M23.04,71C23.02,71,23,70.98,23,70.96v-0.76c0-0.39,0.27-0.86,0.61-1.05c0.17-0.1,0.33-0.11,0.46-0.04 c0.12,0.07,0.19,0.22,0.19,0.42v0.76c0,0.02-0.02,0.04-0.04,0.04s-0.04-0.02-0.04-0.04v-0.76c0-0.17-0.05-0.29-0.15-0.35 c-0.1-0.06-0.23-0.04-0.38,0.04c-0.31,0.18-0.57,0.62-0.57,0.99v0.76C23.08,70.98,23.06,71,23.04,71z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "24.61,69.49 24.61,69.77 24.85,69.63  "
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M24.71,64.2c0.01-0.7-0.97-0.41-0.85,0.66c0.14,1.32,0.2,1.95,0.12,2.42c-0.12,0.37-0.35,0.95-0.52,1.56 c-0.04,0.13-0.19,0.24-0.25,0.44c-0.03,0.12-0.01,0.3,0.02,0.46c0.06,0.29,0.23,0.12,0.23,0.12s0.06,0.08,0.17,0.03 c0.05,0.03,0.13,0.07,0.21,0c0.08-0.07,0.12,0.13,0.24-0.06c0.11-0.19,0.09-0.53-0.02-0.85c0-0.01,0-0.01,0-0.02 c0.16-0.37,0.58-1.22,0.57-1.22C24.99,66.88,24.64,65.09,24.71,64.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 493.7038,
    y1: 227.7257,
    x2: 495.2445,
    y2: 226.9002,
    gradientTransform: "matrix(-0.8266 0.5628 0.5628 0.8266 307.7379 -389.1609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D3E5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5691,
    style: {
      stopColor: "#484B7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#515696"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M27.06,76.04c0.24-0.16,0.61,0.11,0.7,0.42c0,0.13-0.09,0.35-0.09,0.35s-0.39,0.88-0.53,1.02 c-0.13,0.15-0.68,0.36-0.94,0.14c-0.19-0.24,0.18-0.39,0.25-0.63c0.09-0.31,0.05-0.56,0.14-0.8 C26.66,76.35,27.06,76.04,27.06,76.04z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M27.73,76.4C27.73,76.4,27.73,76.4,27.73,76.4c0.01,0.13-0.09,0.35-0.09,0.35s-0.39,0.88-0.53,1.02 c-0.13,0.15-0.68,0.36-0.94,0.14c-0.01-0.01-0.02-0.03-0.03-0.04c0.01,0.03,0.02,0.06,0.05,0.1c0.26,0.22,0.8,0.01,0.94-0.14 c0.13-0.15,0.53-1.02,0.53-1.02s0.1-0.22,0.09-0.35C27.75,76.44,27.74,76.42,27.73,76.4z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M26.41,76.24c0.11-0.08,0.59-0.25,0.59-0.25s0.04,0.05,0.11,0.08c0.01,0,0.01,0,0.02,0.01 c0.12,0,0.33,0.11,0.2,0.35c-0.25,0.46-0.84,0.44-0.78,0.22C26.59,76.5,26.47,76.33,26.41,76.24z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M26.54,76.77c-0.02-0.07-0.04-0.23,0.15-0.26c0.19-0.03,0.41,0.06,0.4,0.18 C27.04,76.93,26.55,76.84,26.54,76.77z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.3855,
    y1: 76.3679,
    x2: 53.8605,
    y2: 76.3679,
    gradientTransform: "matrix(0.9913 -0.1315 0.1315 0.9913 -36.8037 4.3213)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F4E6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3065,
    style: {
      stopColor: "#3E3E5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6997,
    style: {
      stopColor: "#2E2F4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#282A46"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M27.01,75.96c-0.22-0.3-1.65-2.29-2.42-2.56c0.26-1.08,0.98-2.55,0.77-3.71h-1.64c0,0-0.97,3.44-0.35,4.26 c0.47,0.62,2.39,2.08,3.17,2.58C26.93,76.7,27.14,76.19,27.01,75.96z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M26.52,77.09c0.06-0.02,0.23-0.04,0.38,0.02c0.04,0.02,0.09,0,0.11-0.04c0.02-0.04,0-0.09-0.04-0.11 c-0.18-0.08-0.39-0.06-0.49-0.03c-0.04,0.01-0.07,0.06-0.05,0.1C26.43,77.08,26.48,77.11,26.52,77.09z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M26.43,77.38c0.06-0.02,0.23-0.04,0.37,0.02c0.04,0.02,0.09,0,0.11-0.04c0.02-0.04,0-0.09-0.04-0.11 c-0.18-0.08-0.39-0.06-0.49-0.03c-0.04,0.01-0.07,0.06-0.05,0.1C26.35,77.37,26.39,77.39,26.43,77.38z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 623.914,
    y1: 175.1609,
    x2: 625.3112,
    y2: 174.4122,
    gradientTransform: "matrix(-0.9869 -0.161 -0.161 0.9869 669.7334 7.6171)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D3E5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5691,
    style: {
      stopColor: "#484B7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#515696"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M25.87,78.86c0.28,0.05,0.36,0.5,0.22,0.78c-0.09,0.1-0.31,0.19-0.31,0.19s-0.89,0.36-1.09,0.38 c-0.2,0.02-0.64-0.06-0.68-0.4c0.03-0.21,0.21-0.27,0.42-0.39c0.28-0.17,0.52-0.41,0.75-0.52C25.37,78.81,25.87,78.86,25.87,78.86 z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M24.7,80.12c0.21-0.02,1.12-0.39,1.12-0.39s0.21-0.09,0.31-0.19c-0.01,0.03-0.02,0.07-0.04,0.1 c-0.09,0.1-0.31,0.19-0.31,0.19s-0.89,0.36-1.09,0.38c-0.2,0.02-0.64-0.06-0.68-0.4c0-0.01,0-0.01,0.01-0.02 C24.12,80.07,24.52,80.13,24.7,80.12z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M25.27,78.55c0.14,0.02,0.6,0.22,0.6,0.22s-0.01,0.07,0.02,0.13c0,0.01,0.01,0.01,0.01,0.02 c0.08,0.08,0.17,0.23-0.08,0.31c-0.5,0.16-0.93-0.18-0.73-0.29C25.22,78.87,25.25,78.66,25.27,78.55z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M25,79.01c0.04-0.05,0.12-0.18,0.28-0.07c0.16,0.11,0.2,0.25,0.18,0.36c-0.02,0.11-0.35,0.03-0.36,0.01 C25.08,79.3,25,79.01,25,79.01z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M24.85,79.15c0.07,0.03,0.23,0.14,0.3,0.29c0.02,0.04,0.07,0.06,0.12,0.04c0.04-0.02,0.06-0.07,0.04-0.12 c-0.09-0.2-0.28-0.33-0.39-0.38c-0.05-0.02-0.1,0-0.12,0.05C24.78,79.08,24.8,79.13,24.85,79.15z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M24.57,79.33c0.07,0.03,0.22,0.13,0.3,0.29c0.02,0.04,0.07,0.06,0.12,0.04c0.05-0.02,0.06-0.07,0.04-0.12 c-0.09-0.2-0.28-0.33-0.39-0.38c-0.05-0.02-0.1,0-0.12,0.05C24.51,79.26,24.53,79.31,24.57,79.33z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.4544,
    y1: 73.9278,
    x2: 26.8947,
    y2: 74.502
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#61607F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4465,
    style: {
      stopColor: "#464664"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#282A46"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M25.16,69.64c0,1.54-0.02,3.26-0.02,4.6c0,1.54,0,3.15,0.02,4.43c-0.01,0.39,0.6,0.44,0.79,0.1 c0.16-1.17,0.47-2.59,0.38-3.87c0.39-1.68,1.04-3.84,0.88-5.16C26.83,69.86,25.53,69.52,25.16,69.64z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.5382,
    y1: 67.6013,
    x2: 27.3187,
    y2: 67.6013
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAF6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4383,
    style: {
      stopColor: "#F99062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F36B55"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M26.67,67.53c-0.07-1.19,0.77-3.58,0.6-3.71c-0.56-0.45-0.91-0.53-1.8-0.51c-0.89,0.02-1.31,0.21-1.49,0.82 c-0.17,0.58-0.29,0.75-0.43,1.32c-0.06,0.25,0.14,1.03,0.19,1.84c0.06,0.98,0.08,1.85-0.11,2.64c0.14,0.06,0.21,0.1,0.49,0.19 c1.49,0.51,2.37,1.22,2.99,1.77c0.08-0.56,0.27-1.36,0.18-2.16C27.2,68.85,26.71,68.13,26.67,67.53z"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "28.85,74.7 26.35,76.14 26.19,72.21 28.69,70.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "26.35,76.14 25.79,75.82 25.94,72.07 26.07,72.14 26.19,72.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "25.94,72.07 26.19,72.21 28.44,70.9 28.44,70.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "28.69,74.55 28.2,74.83 28.2,74.69 28.68,74.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "28.68,74.27 28.45,74.4 28.44,74.27 28.67,74.14  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M26.88,72.13c-0.02,0-0.04-0.02-0.04-0.04v-0.76c0-0.39,0.27-0.86,0.61-1.05c0.17-0.1,0.33-0.11,0.46-0.04 c0.12,0.07,0.19,0.22,0.19,0.42v0.76c0,0.02-0.02,0.04-0.04,0.04c-0.02,0-0.04-0.02-0.04-0.04v-0.76c0-0.17-0.05-0.29-0.15-0.35 c-0.1-0.06-0.23-0.04-0.38,0.04c-0.31,0.18-0.57,0.62-0.57,0.99v0.76C26.92,72.12,26.9,72.13,26.88,72.13z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "28.44,70.62 28.44,70.9 28.69,70.76  "
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M28.21,67.5c-0.03-0.35-0.45-2.94-0.79-3.54c-0.15-0.25-0.45-0.39-0.62-0.46c-0.32,0.02-0.66,0.46-0.55,1.03 c0.11,0.55,0.44,0.74,0.46,0.75c0.3,0.63,0.56,1.94,0.69,2.39c0.03,0.31-0.09,1.65-0.12,2.05c-0.01,0.21-0.34,0.48-0.24,0.96 c0.06,0.29,0.23,0.12,0.23,0.12s0.06,0.08,0.17,0.03c0.05,0.03,0.13,0.07,0.21,0c0.08-0.07,0.12,0.13,0.24-0.06 c0.11-0.19,0.09-0.53-0.02-0.85C27.84,69.03,28.26,68.12,28.21,67.5z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M25.82,62.12c-0.02-0.27-0.95,0.27-0.93,0.63c0.02,0.29,0.06,0.59-0.06,0.63c-0.27,0.2,0.24,0.52,1.65,0 C26.2,63.32,25.87,63,25.82,62.12z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M0,83.83c0.14-0.41,0.5-1.15,1.76-0.46c1.26,0.69,1.96,0,1.8-0.56c0.55,1.09-0.44,2.16-1.49,1.91 c-1.05-0.25-1.63-1.24-1.81-0.69C0.12,84.42,0,83.83,0,83.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M26.05,61.74l-0.28-0.71h-1.79v1.08c0,0.6,0.4,1.08,0.9,1.08c0.48,0,0.87-0.46,0.89-1.03l0.12,0L26.05,61.74 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M25.61,62.71c-0.15,0.27-0.41,0.46-0.7,0.47c0,0.09-0.02,0.15-0.06,0.18c0.05,0,0.1-0.01,0.15-0.02 C25.3,63.27,25.52,63.03,25.61,62.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M24.99,60.28c-0.01,0-0.01,0-0.02,0c-0.98,0.02-1.05,0.75-1,0.88c0.31,0.11,0.51-0.1,0.7-0.08 c0.09,0.01,0.48,0.06,0.63,0.26c0.17,0.22,0.12,0.56,0.28,0.56c0.07,0,0.09-0.24,0.19-0.24c0.09,0,0.17,0.08,0.16,0.21 c-0.01,0.18-0.18,0.29-0.16,0.38c0.04,0.14,0.4-0.11,0.39-0.62C26.17,61.1,25.83,60.24,24.99,60.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M25.23,60.29c1.09,0.25,1,1.08,1.4,1.34c0.24,0.16,0.78-0.14,1.09,0.4c0.36,0.62-0.22,0.85,0.16,1.12 c0.38,0.26,0.68,1.07,0.04,1.57c-0.64,0.5-1.43,0.06-1.34-0.67c0.06-0.52-0.09-0.79-0.53-0.62c-0.33,0.13-0.45-0.13-0.31-0.47 c-0.73,0.07,0.04-1.32-1.07-1.9C24.72,60.79,25.23,60.29,25.23,60.29z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.3911,
    y1: 83.5709,
    x2: 62.0836,
    y2: 83.5709
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4CAE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    style: {
      stopColor: "#CED3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4088,
    style: {
      stopColor: "#E9EBF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6869,
    style: {
      stopColor: "#F9FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8989,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55.39,
    y: 82.96,
    className: "st73",
    width: 6.69,
    height: 1.23
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.3114,
    y1: 81.796,
    x2: 59.0039,
    y2: 81.796
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4CAE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    style: {
      stopColor: "#CED3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4088,
    style: {
      stopColor: "#E9EBF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6869,
    style: {
      stopColor: "#F9FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8989,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52.31,
    y: 81.18,
    className: "st74",
    width: 6.69,
    height: 1.23
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 505.7822,
    y1: 81.5598,
    x2: 508.2491,
    y2: 81.5598,
    gradientTransform: "matrix(-1 0 0 1 559.8527 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#282A46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    style: {
      stopColor: "#2F314E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D3E5D"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M51.6,82.03c0-0.97,0.61-0.99,0.61-0.99s0.33,0,0.87-0.22c0.53-0.22,1.28-0.14,0.86,0.64 c0,0.01-0.01,0.02-0.01,0.03c-0.03,0.04-0.07,0.08-0.14,0.12l-1.34,0.78C52.26,82.5,51.61,82.23,51.6,82.03z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M51.61,81.95c0.01,0.2,0.65,0.46,0.85,0.35l1.34-0.78c0.04-0.03,0.12-0.08,0.19-0.14 c-0.01,0.03-0.02,0.05-0.04,0.08c0,0.01-0.01,0.02-0.01,0.03c-0.03,0.04-0.07,0.08-0.14,0.12l-1.34,0.78 c-0.19,0.11-0.77-0.12-0.85-0.31c0-0.01-0.01-0.03-0.01-0.04C51.6,82,51.61,81.97,51.61,81.95z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M51.85,80.91c0.16,0,0.71,0.14,0.71,0.14s0,0.08,0.05,0.14c0.01,0.01,0.01,0.01,0.02,0.02 c0.11,0.08,0.22,0.2-0.04,0.36c-0.21,0.13-0.39,0.05-0.47-0.03c-0.03-0.06-0.08-0.13-0.15-0.17c-0.07-0.04-0.11-0.06-0.14-0.06 c0,0,0-0.01,0-0.01S51.79,80.91,51.85,80.91z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M51.84,71.46c0.6,0.01,2.12,0.04,2.72,0.05c-0.23,1.82-0.68,3.47-0.98,5.23c-0.32,1.71-0.69,2.91-1.01,4.34 c-0.12,0.27-0.65,0.16-0.76-0.09c-0.08-1.31-0.18-2.91,0.21-4.42C51.96,74.94,51.8,73.11,51.84,71.46z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 502.7321,
    y1: 83.3353,
    x2: 505.199,
    y2: 83.3353,
    gradientTransform: "matrix(-1 0 0 1 559.8527 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#282A46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    style: {
      stopColor: "#2F314E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D3E5D"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M54.65,83.81c0-0.97,0.61-0.99,0.61-0.99s0.33,0,0.87-0.22c0.53-0.22,1.28-0.14,0.86,0.64 c0,0.01-0.01,0.02-0.01,0.03c-0.03,0.04-0.07,0.08-0.14,0.12l-1.34,0.78C55.31,84.28,54.66,84.01,54.65,83.81z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M54.66,83.72c0.01,0.2,0.65,0.46,0.85,0.35l1.34-0.78c0.04-0.03,0.12-0.08,0.19-0.14 c-0.01,0.03-0.02,0.05-0.04,0.08c0,0.01-0.01,0.02-0.01,0.03c-0.03,0.04-0.07,0.08-0.14,0.12l-1.34,0.78 c-0.19,0.11-0.77-0.12-0.85-0.31c0-0.01-0.01-0.03-0.01-0.04C54.65,83.78,54.66,83.75,54.66,83.72z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M54.9,82.69c0.16,0,0.71,0.14,0.71,0.14s0,0.08,0.05,0.14c0.01,0.01,0.01,0.01,0.02,0.02 c0.11,0.08,0.22,0.2-0.04,0.36c-0.21,0.13-0.39,0.05-0.47-0.03c-0.03-0.06-0.08-0.13-0.15-0.17c-0.07-0.04-0.11-0.06-0.14-0.06 c0,0,0-0.01,0-0.01S54.84,82.69,54.9,82.69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 503.8032,
    y1: 77.4409,
    x2: 508.0442,
    y2: 77.4409,
    gradientTransform: "matrix(-1 0 0 1 559.8527 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D3E5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3181,
    style: {
      stopColor: "#444464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F4E6E"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M53.76,75.79c-0.17-0.78-2.07-0.88-1.95-3.95c0.6-0.09,3.62,1.33,4.22,1.24c0.07,1.83-0.1,3.53-0.11,5.32 c-0.04,1.74-0.21,2.99-0.29,4.45c-0.07,0.28-0.62,0.27-0.76,0.04c-0.3-1.28-0.65-2.84-0.52-4.4 C54.17,77.62,53.96,76.7,53.76,75.79z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.6455,
    y1: 68.9082,
    x2: 50.9634,
    y2: 68.3656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D8DEF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2962,
    style: {
      stopColor: "#E9ECF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6949,
    style: {
      stopColor: "#F9FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M53.19,65.86c-2.13,1.42-2.38,4.25-1.23,6.04C51.96,71.91,51.71,67.93,53.19,65.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 503.6395,
    y1: 69.83,
    x2: 508.0694,
    y2: 69.83,
    gradientTransform: "matrix(-1 0 0 1 559.8527 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D8DEF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2962,
    style: {
      stopColor: "#E9ECF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6949,
    style: {
      stopColor: "#F9FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M53.1,73.58c1.3,0.73,2.65,0.73,3.12-0.17c-0.17-1.67-0.34-3.02,0-4.62c-0.1-0.88-0.17-1.01-0.06-1.53 c-0.04-0.17-0.57-0.54-0.96-0.89c-0.42-0.38-0.7-0.74-0.91-0.79c-1.77-0.36-2.63,2.8-2.49,6.17 C51.94,72.65,52.46,73.22,53.1,73.58z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M53.3,65.79c0.38-0.28,0.33-0.46,0.27-0.84c-0.07-0.2-0.12-0.42-0.12-0.65c0-0.84,0.54-1.57,1.19-1.53 c1.32,0.09,1.09,0.79,1.09,1.63c0,0.78-0.35,1.32-0.95,1.41c0,0.13,0.03,0.2,0.2,0.36c-0.43,0.26-1.06,0.14-1.31,0.02 C53.41,66.08,53.12,65.97,53.3,65.79z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M55.15,62.32c-0.04-0.1-0.24-0.16-0.91,0.15c0,0-0.16,0.08-0.17,0.08c-1.23,0.63-0.82,2.07-0.61,2.44 c0.08,0.13,0.13,0.24,0.13,0.45c0.49-0.05,0.67,0.21,0.97-0.08c0.21-0.21,0.54-0.47,0.59-0.57c0.05-0.1,0.04-0.17,0.03-0.24 c-0.05-0.7,0.31-0.29,0.31-0.13c0.13-0.07,0.1-0.35,0.07-0.66h0C56.57,62.88,55.96,62.37,55.15,62.32z"
  }))), /*#__PURE__*/React.createElement("g", null, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M56.06,74.03c-0.16,0.17-0.45,0.22-0.64,0.02c-0.21-0.22-0.09-0.47-0.2-0.54c-0.31-0.2-0.39-0.39-0.33-0.58 c0.25,0.16,0.51,0.42,0.73,0.26c0.22-0.16,0.5-0.37,0.52-0.59c0.33,0.08,0.34,0.78,0.17,1.07C56.14,73.93,56.06,74.03,56.06,74.03 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.1342,
    y1: 71.4001,
    x2: 54.2003,
    y2: 70.0165
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BDC3E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3783,
    style: {
      stopColor: "#C2C8E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#D1D7EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8DEF0"
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M55.62,73.47c-0.16,0.4-0.05,0.64,0.35,0.68c0.99-0.51,1.57-1.93,1.58-2.71c0.03-1.3-0.6-2.94-1.41-4.22 c-0.19-0.28-0.79-0.17-1.08,0.22c-0.4,0.53-0.23,1.3,0,1.61c0.58,0.93,1.23,1.62,1.29,2.37C56.41,72.11,56.12,73.02,55.62,73.47z"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8_copy"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartProject9420);
export default __webpack_public_path__ + "static/media/cart-project-9420.3c718ac83530892d816fb5d83e29d880.svg";
export { ForwardRef as ReactComponent };